"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tldts = require("tldts");
// 获取二级域名
const getSubdomain = function () {
  var _parsedHref$hostname;
  let href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  const parsedHref = (0, _tldts.parse)(href);
  const subdomain = (_parsedHref$hostname = parsedHref.hostname) === null || _parsedHref$hostname === void 0 ? void 0 : _parsedHref$hostname.replace(/^m\.{1}/, '');
  const cookiesDomain = parsedHref.isIp || parsedHref.isPrivate || !subdomain || !parsedHref.domain ? undefined : '.' + subdomain;
  return cookiesDomain;
};
var _default = exports.default = getSubdomain;